import Typography from '@mui/material/Typography';

// ==============================|| LOGO TEXT ||============================== //

export default function LogoMain() {
  return (
    <Typography variant="h5" component="span" sx={{ fontWeight: 700, letterSpacing: 0.4 }}>
      Assessor Dashboard
    </Typography>
  );
}
